export function startTour(state) {
  return {
    ...state,
    ...setTourProperties(),
  };
}

function setTourProperties() {
  return {tour: true, stepIndex: 0};
}
